import React from "react";
import {BackTop, Row, Col} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, instituteModel } from "@reco-w/institute-models";

export namespace Institute {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, instituteModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.institute;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/institute`);
        }
        componentDidMount() {
            this.dispatch("input", {})
        }


        renderService() {
            return (
                <div className="block-content institute-content">
                    <div className="container">
                        <div className="second-title line-no">
                            <img src="assets/images/second/yjy-title1.png" />
                        </div>
                        <div className="company-info">
                            <i className="icon iconyinhao1" />
                            <span>瑞谷产业研究院</span>是从事产业生态发展研究的专业机构，针对企业成长环境竞争力进行深度剖析研究，建立评价指标体系，研究不同区域、园区等企业成长环境的差异，并分析产生差异的原因，同时有针对性地提出提高企业成长环境竞争力的措施和建议。
                            利用产品思维打造科创产业生态，对产业生态进行精准定位，最终实现产业汇聚、精准招商，完成以产业带动发展的目标。
                            <i className="icon iconyinhao2" />
                        </div>
                    </div>
                </div>
            )
        }

        renderReport() {
            return (
                <div className="block-content report-content">
                    <div className="container">
                        <div className="second-title line-no">
                            <img src="assets/images/second/yjy-title2.png" />
                        </div>
                    </div>
                    <Row className="report-gird">
                        <Col xs={24} sm={24} md={24} lg={12}>
                            <div className="report-gird-item">
                                <ImageAuto.Component src="assets/images/second/baog-bg1.jpg" width="100%" height="100%" />
                                <div className="report-gird-word">
                                    <img className="word-img" src="assets/images/second/baog-word1.jpg" />
                                    <img className="word-img2" src="assets/images/second/yjy-word1.png" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12}>
                            <div className="report-gird-item">
                                <ImageAuto.Component src="assets/images/second/baog-bg2.jpg" width="100%" height="100%" />
                                <div className="report-gird-word">
                                    <img className="word-img" src="assets/images/second/baog-word2.jpg" />
                                    <img className="word-img2" src="assets/images/second/yjy-word2.png" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12}>
                            <div className="report-gird-item">
                                <ImageAuto.Component src="assets/images/second/baog-bg3.jpg" width="100%" height="100%" />
                                <div className="report-gird-word">
                                    <img className="word-img" src="assets/images/second/baog-word3.jpg" />
                                    <img className="word-img2" src="assets/images/second/yjy-word3.png" />
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={12}>
                            <div className="report-gird-item">
                                <ImageAuto.Component src="assets/images/second/baog-bg4.jpg" width="100%" height="100%" />
                                <div className="report-gird-word">
                                    <img className="word-img" src="assets/images/second/baog-word4.jpg" />
                                    <img className="word-img2" src="assets/images/second/yjy-word4.png" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/yjy-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">瑞谷研究院</div>
                                <div className="banner-text-name2 mt25">
                                    产业生态发展研究专业机构
                                </div>
                            </div>}
                        />
                        {this.renderService()}
                        {this.renderReport()}
                        <div><img src="assets/images/second/mountain.jpg" width="100%" /></div>
                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.institute]);
}
